var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('el-empty',{attrs:{"description":"敬请期待"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }